/************************************************************************************
	Estas funciones están relacionadas con el sercicio TS del protocolo DVB-CSS
    Estas funciones son utilizadas por los esclavos para recibir las marcas de tiempo
    transmitidas por el maestro y obtener la diferencia de tiempo en la reproducción
    del contenido para actuar en consecuencia (play, pause o set currentTime).
************************************************************************************/
import {changeCameraTrack, changeAudioTrack, changeCameraPosition, changeVolume} from "../client";
import {video, wallClock} from "../client";


export function syncContentTime(cii, master){

  let ts_ws = new WebSocket(cii.private[0].tsUrl, 'echo-protocol');

	// Al abrir el socket se envia el sigueinte mensaje para incluir este cliente 
	// en la lista del servidor como sockets conectados
	ts_ws.onopen = function() 
{
	var json = {
		contentIdStem: 'this:is:new:stem',
		timelineSelector: 'this:is:new:timeline:selector'
	};
	ts_ws.send(JSON.stringify(json));

};

  /**
   * Manejador del evento onmessage del WebSocket.
   * Se encarga de recibir los mensajes del servidor y actuar en consecuencia.
   * Si el mensaje contiene una marca de tiempo de contenido, se ajusta el reproductor
   * para sincronizarlo con el servidor.
   * Si el mensaje contiene una acción, se ejecuta la acción correspondiente.
   * @param {MessageEvent} message - El mensaje recibido del servidor.
   */
  ts_ws.onmessage = function(message) 
	{ 
		var data = JSON.parse(message.data);

		// En caso de ser un cliente esclavo se realiza el ajuste de sincronización 
		// con la información recibida
		if (!master){
			if (data.contentTime)
			{
				var syncTime = data.contentTime / 1000000000; //s		
				var wcServer = data.wallClockTime / 1000000000; //s
				checkSync(data.timelineSpeedMultiplier, syncTime, wcServer);
			}
			else if (data.action)
			{
				switch (data.action) {
					case 'nextCamera':
						changeCameraTrack(data.cameraTrack);
						break;

					case 'nextAudio':
						changeAudioTrack(data.audioTrack);
						break;

					case 'cameraPosition':
						changeCameraPosition(data.cameraPosition);
						break;

					case 'volume':
						changeVolume(data.volume);
						break;
				}
			}
		}
	};   
}

// Función encargada de realizar el ajuste de sincronización del cliente esclavo
function checkSync(isPlaying, syncTime, wcServer) {

    var wcClient = (wallClock.getTicks() / 1000000000); //s
    var currentTime = video.currentTime;

    // Definición de los límites de la zona estable -> -limInf to limInf
    var limInf = 0.05;

    // Definición del límite máximo de ajuste de velocidad 
    // de reproducción -> [-limSup , -limInf] y [limInf , limSup]
    var limSup = 1;

    var aux;
    var diff = 0;

    // Se realiza la sincronización si el contenido se está reproduciendo
    if (isPlaying) {

			// Cálculo de la diferencia de tiempo entre relojes de cliente y servidor 
			diff = Math.round(((wcServer - syncTime) - (wcClient - currentTime)) * 1000) / 1000; //s

			// Se reactiva el video del cliente en el caso de encontrarse parado
			if (video.paused) {

				video.play();
			}

			// Se comprueba si la diferencia se encuentra dentro de la zona estable
			if (diff <= limInf && diff >= -limInf){

				video.playbackRate = 1;
			
			// Se comprueba si la diferencia se encuentra dentro de los límites de ajuste de velocidad
			} else if (diff > limInf && diff <= limSup || diff < -limInf && diff >= -limSup) {

					aux = 1 - Math.trunc(diff * 50) / 100;
					if (aux < 0.5){ 
						aux = 0.5;
					}
					video.playbackRate = aux;

			// Se salta a un posición diferente del video si la diferencia 
			// supera los límites de ajuste de velocidad
			}else if (diff < -limSup) {
					
				video.currentTime = Math.round(video.currentTime - diff + 0.5);
			
			}else if (diff > limSup) {
					
				video.currentTime = Math.round(video.currentTime - diff);
			
			}
    } else {

      // Si el video se encuentra en pausa no se realiza ninguna sincronización
      video.pause();
    }
}